import { gql } from '@apollo/client';
import allMutations from './all-mutations';
import dynamicMutations from './dynamic/all-dynamic-mutations';

const fireError = () => gql`
  query ErrorLog {
    error @client
  }
`;

const getMutation = mutation =>
  allMutations[mutation]
    ? gql`
        ${allMutations[mutation]}
      `
    : fireError();

const getDynamicMutation = mutation =>
  dynamicMutations[mutation]
    ? dynamicMutations[mutation]
    : console.error(`Mutation provided: ${mutation} doesn't exist`); //eslint-disable-line

export default getMutation;
export { getDynamicMutation };
